// extracted by mini-css-extract-plugin
module.exports = {"policy":"PolicyText-module--policy--10aCG"};